var map = {
	"./0_global/MoreMenuPopup.tsx": 9273,
	"./10_footer/Footer.tsx": 9005,
	"./1_header/Header.tsx": 2186,
	"./1_header/components/Logo.tsx": 3506,
	"./1_header/components/MoreButton.tsx": 1254,
	"./1_header/components/StartButton.tsx": 2354,
	"./2_welcome/Welcome.tsx": 5270,
	"./2_welcome/components/BannerDescription.tsx": 4819,
	"./2_welcome/components/EnterButton.tsx": 3498,
	"./3_story/Story.tsx": 9751,
	"./3_story/components/BackButton.tsx": 3612,
	"./4_starDuke/StarDuke.tsx": 6843,
	"./4_starDuke/components/LevelCard.tsx": 8532,
	"./5_nft/Nft.tsx": 9473,
	"./5_nft/components/StarLine.tsx": 8282,
	"./6_tokenomics/Tokenomics.tsx": 5397,
	"./6_tokenomics/components/ItemCard.tsx": 7478,
	"./6_tokenomics/components/PieChart.tsx": 3922,
	"./7_features/Features.tsx": 9565,
	"./7_features/components/FeaturesCard.tsx": 5241,
	"./8_officalPartners/OfficalPartners.tsx": 240,
	"./8_officalPartners/components/OfficalPartnersCard.tsx": 1845,
	"./8_officalPartners/components/OfficalPartnersIcon.tsx": 538,
	"./9_roadMap/RoadMap.tsx": 2897,
	"./9_roadMap/components/PhaTabButton.tsx": 7200,
	"./9_roadMap/components/TimeAxis.tsx": 1334,
	"./common/Banner.tsx": 1688,
	"./common/BasicTip.tsx": 2136,
	"./common/BasicTitle.tsx": 6691,
	"./common/Description.tsx": 1002
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 254;